export { default } from './PhishingCatcherLayout';
